const $$splitComponentImporter = () => import('/app/frontend/src/routes/_anon/login.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_anon/login')({
  staticData: {
    breadCrumb: 'Login',
    backgroundImage: '/login_background.jpg'
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});